module.exports = "<div class=\"bgimg\">\n  <div class=\"front-middle-div\" style=\"white-space:nowrap;\">\n    <span class=\"front-middle-box\">虾丸，追梦</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/home/home.com.html
// module id = ./src/app/com/home/home.com.html
// module chunks = main